<template>
  <div class="pdfLoaderComponent">
    <pdf
      :src="src"
      :page="currentPage"
      @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"
      @loaded="loadPdfHandler"
    >
    </pdf>
    <p class="pager">
      <span
        @click="changePdfPage(0)"
        class="turn"
        :class="{ grey: currentPage == 1 }"
        >上一页</span
      >
      {{ currentPage }} / {{ pageCount }}
      <span
        @click="changePdfPage(1)"
        class="turn"
        :class="{ grey: currentPage == pageCount }"
        >下一页</span
      >
    </p>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  name: "pdfLoaderComponent",
  components: {
    pdf,
  },
  props:{
    src:{
        type:String
    }
  },
  data() {
    return {
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
    };
  },
  methods: {
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
  },
};
</script>
<style lang="less" scoped>
.pdfLoaderComponent{
 border: 1px solid #ccc;
 padding: 20px;
 .pager{
   text-align: center;
   position: relative;
   span{
       cursor: pointer;
   }
 }
}
</style>


// WEBPACK FOOTER //
// src/common/pdfLoader.vue